import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import { Text, Box, Link } from 'components/ui';
import CompareZoneBase from 'components/Catalog/ProductGrid/CompareModal/Zones/CompareZoneBase';
import { fontSizes, lineHeights } from 'style/config';

const IngredientContent = ({ sku, getText }) => {
    const [showAll, setShowAll] = useState(false);
    const [hasOverflow, setHasOverflow] = useState(false);
    const textRef = useRef(null);

    const checkOverflow = () => {
        if (textRef.current && !showAll) {
            setHasOverflow(textRef.current.scrollHeight > textRef.current.offsetHeight);
        }
    };

    useEffect(() => {
        checkOverflow();
        window.addEventListener('resize', checkOverflow);

        return () => window.removeEventListener('resize', checkOverflow);
    }, [sku.ingredientDesc, showAll]);

    const toggleShowAll = () => {
        setShowAll(!showAll);
    };

    const lineHeight = fontSizes['lg-bg'] * lineHeights['none']; // Calculate line height in pixels
    const maxLinesCollapsed = 7; // Show 7 lines when collapsed
    const maxHeight = lineHeight * maxLinesCollapsed;

    return (
        <Box baseCss={{ gap: 0 }}>
            <Box
                ref={textRef}
                overflow='hidden'
                maxHeight={showAll ? 'none' : `${maxHeight}px`}
            >
                <Text
                    fontSize='base'
                    lineHeight={`${fontSizes['lg-bg']}px`}
                    is='p'
                    dangerouslySetInnerHTML={{ __html: sku.ingredientDesc || '-' }}
                />
            </Box>
            {hasOverflow && !showAll && (
                <Link
                    onClick={toggleShowAll}
                    color='blue'
                    fontSize='base'
                    css={{ cursor: 'pointer' }}
                >
                    {getText('showAll')}
                </Link>
            )}
        </Box>
    );
};

IngredientContent.propTypes = {
    sku: PropTypes.object.isRequired,
    getText: PropTypes.func.isRequired
};

const IngredientsZone = ({ skus = [], getText = () => {} }) => {
    const renderContent = sku => {
        return (
            <IngredientContent
                sku={sku}
                getText={getText}
            />
        );
    };

    return (
        <CompareZoneBase
            skus={skus}
            getText={getText}
            titleKey='ingredients'
            renderContent={renderContent}
        />
    );
};

IngredientsZone.propTypes = {
    skus: PropTypes.arrayOf(PropTypes.object),
    getText: PropTypes.func
};

export default wrapFunctionalComponent(IngredientsZone, 'IngredientsZone');
